<template>
  <b-modal ref="mdlConfigurazioneMagazzinoImballoArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
    <b-row>
      <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
        <label class="sa-label-data">Codice Azienda</label>
        <b-form-select v-model="localData.codiceAzienda">
          <template #first>
            <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
          </template>
          <b-form-select-option v-for="item in strutturaOptions" :key="item.id" :value="item.codiceStruttura"
            ><span>{{ `${item.denominazione} (${item.codiceStruttura}) ` }}</span></b-form-select-option
          >
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
        <label class="sa-label-data">Peso Imballo (KG)</label>
        <span v-if="isReadOnly"> {{ localData.pesoImballo }}</span>
        <b-form-input v-else v-model="localData.pesoImballo" type="number" min="0"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Descrizione Imballo</label>
        <span v-if="isReadOnly">{{ localData.descrizioneImballo }}</span>
        <b-textarea v-else v-model="localData.descrizioneImballo" rows="7" max-rows="10"></b-textarea>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
      <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaImballoArticolo">Salva</b-button>
      <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
export default {
  mixins: [UtilityMixin, StruttureMixin, MagazzinoMixins],
  components: { ModalError },
  data() {
    return {
      title: null,
      pathResourceImballoArticoli: "/magazzinoarticoliimballi",
      isReadOnly: false,
      localData: {
        id: null,
        codiceAzienda: null,
        pesoImballo: null,
        descrizioneImballo: null,
      },
    };
  },
  mounted() {
    this.struttureLoadData();
  },
  props: {
    jsonData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  methods: {
    show(jsonData, isReadOnly) {
      let me = this;
      me.localData = jsonData;
      me.isReadOnly = isReadOnly;
      if (me.jsonData) {
        this.localData.codiceAzienda = me.jsonData.codiceAzienda;
      }
      if (isReadOnly) {
        me.title = "Visualizzazione Imballo";
      } else {
        me.title = !jsonData.id ? "Nuovo Imballo" : "Aggiorna Imballo";
      }

      me.$refs.mdlConfigurazioneMagazzinoImballoArticoli.show();
    },
    onCloseModal() {
      let me = this;
      me.localData = {
        id: null,
        codiceAzienda: null,
        pesoImballo: null,
        descrizioneImballo: null,
      };
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneMagazzinoImballoArticoli.hide();
    },
    onClickSalvaImballoArticolo() {
      let me = this;
      UtilityMixin.methods.saveResource(me.pathResourceImballoArticoli, me.localData, me.salvaImballoArticoloSuccess, me.salvaImballoArticoloError);
    },
    salvaImballoArticoloSuccess(response) {
      let me = this;
      me.$emit("saveImballoArticolo", response);
      me.$refs.mdlConfigurazioneMagazzinoImballoArticoli.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaImballoArticoloError(error) {
      let me = this;
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },
    onDeleteImballoArticolo(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questo imballo?", {
          title: "Eliminazione Imballo",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteImballoArticolo(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteImballoArticolo(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResourceImballoArticoli + "/" + id, null, me.deleteImballoArticoloSuccess, me.deleteImballoArticoloError);
    },
    deleteImballoArticoloSuccess(response) {
      let me = this;
      me.$emit("imballoArticoloDelete", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    deleteImballoArticoloError(response) {
      let me = this;
      me.$emit("imballoArticoloDelete", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
